export default __webpack_public_path__ + "static/media/HeaderBackground.cc404072.jpg";